import React from "react";
import { Box, Typography, Grid } from "@mui/material";

const ActivitieCard = ({ image, title, description, index }) => {
  return (
    <Box
      sx={{
        
        borderRadius: 2,
        padding: 2,
        mb: 4, // Add some margin between cards
      }}
    >
      <Grid
        container
        spacing={4}
        alignItems="center"
        direction={index % 2 === 0 ? "row" : "row-reverse"} // Alternates image position
      >
        {/* Left or Right Side: Image */}
        <Grid item size={{ xs: 12, md: 6}}>
          <Box
            component="img"
            src={image} // Replace with your image path
            alt={`${title} example`}
            sx={{
              width: "100%",
              maxWidth: "400px",
              display: "block",
              margin: "0 auto",
            }}
          />
        </Grid>

        {/* Opposite Side: Text */}
        <Grid item size={{ xs: 12, md: 6  }}>
          <Typography
            variant="h4"
            sx={{ fontWeight: "bold", color: "#1976d2", mb: 2 }}
          >
            {title}
          </Typography>
          <Typography variant="body1" textAlign={"justify"} sx={{ color: "#555", mb: 4 }}>
            {description}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ActivitieCard;
